<template>
  <div class="h-px bg-gray-300"></div>
</template>
